import { $, owlCarousel } from "./imports";
import tagsCarousel from "./tags-carousel";

const productsHome = () => {
    if($('.products-home__list').length > 0){

        $('.products-home__list').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            dotsEach: calculateDotsEach,
            margin: 16,
            autoWidth: true,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            rewind: true,
            loop: true,
            items: 1,
            touchDrag: true,
            pullDrag: true,
            responsive: {
                0: {
                    items: 1.08,
                    // autoWidth: false,
                },
                768: {
                //     autoWidth: false,
                    nav: true,
                    // items: 1,
                    items: 1.1,
                    margin: 16,
                },
                992: {
                    margin: 50,
                    items: 2,
                    nav: true,
                    autoWidth: true,
                }
            },
            onInitialized: tagsCarousel,
            // onChanged: showHidePrevNav
        });

        $('.products-home__list').trigger("refresh.owl.carousel");

        function showHidePrevNav(event){
            let currentIndex = event.item.index;
            let $prevBtn = $(event.target).find('.owl-nav button.owl-prev');
    
            if(currentIndex >=  1){
                $prevBtn.css('display', 'flex');
            }else{
                $prevBtn.css('display', 'none');
            }

        }

        function calculateDotsEach() {
            // Calcular la cantidad de puntos a mostrar
            let itemCount = $('.products-home__list').find('.owl-item').length;
            return Math.min(5, itemCount); // Limitar a un máximo de 5 puntos
        }
    }
    /*
    // Para los selects
    if($('.products-home').length > 0){
        const $businessTypeSelect = $('.products-home form select[name="business_type"]');
        const $productTypeSelect = $('.products-home form select[name="product_type"]');

        // Guarda las opciones del segundo select en sessionStorage
        function saveProductOptions() {
            const options = $productTypeSelect.find('option').map(function() {
                return $(this).prop('outerHTML');
            }).get();
            sessionStorage.setItem('productTypeOptions', JSON.stringify(options));
        }

        // Carga las opciones del segundo select desde sessionStorage
        function loadProductOptions() {
            const options = JSON.parse(sessionStorage.getItem('productTypeOptions'));
            if (options) {
                $productTypeSelect.html(options.join('') );
            }
        }

        // Escucha cambios en el primer select
        $businessTypeSelect.on('change', () =>{
            if($(this).val() !== 'All'){
                saveProductOptions();
            }
        });

        $productTypeSelect.on('change', () => {
            if($(this).val() !== 'All'){
                // Guarda la opción seleccionada en sessionStorage
                sessionStorage.setItem('selectedProductType', $productTypeSelect.val() );
            }
        });

        $('body').on('click', '.products-home form .form-actions .button--secondary.inputreplace', () =>{
            sessionStorage.setItem('productsHomeClick', 'true');
        });

        // Si ya se le habia hecho click y se esta ejecuntando en ajaxComplete
        if(sessionStorage.getItem('productsHomeClick') ){
            // Verifica si ya se hicieron cambios en el primer select
            if (sessionStorage.getItem('productTypeOptions')) {
                // Carga las opciones guardadas en el segundo select
                loadProductOptions();
                // Verificar si ya se habia seleccionado una opción
                if(sessionStorage.getItem('selectedProductType')){
                    // setear valor
                    $productTypeSelect.val( sessionStorage.getItem('selectedProductType') );
                    // Limpia la entrada en el sessionStorage
                    sessionStorage.removeItem('selectedProductType');
                }
                // Limpia la entrada en el sessionStorage
                sessionStorage.removeItem('productTypeOptions');
            }
            // Limpia la entrada en el sessionStorage
            sessionStorage.removeItem('productsHomeClick');
        }
    }
    */
}

export default productsHome;